<template>
    <i
        class="uikon"
        :class="{'uikon--close': icon === 'close'}"
    >
        {{ (icon === 'close' ? 'add' : icon) }}
        <slot></slot>
    </i>
</template>

<script>
export default {
    name: "Uikon",
    props: {
        icon: { type: String, default: "" }
    }
}
</script>

<style lang="scss">
@charset "UTF-8";
@font-face {
  font-family: 'uikon';
  src: url(/media/uikon.6d70aa99.eot);
  src: url(/media/uikon.6d70aa99.eot#iefix) format("embedded-opentype"), url(/media/uikon.073b232b.ttf) format("truetype"), url(/media/uikon.20a6441b.woff) format("woff"), url(/media/uikon.75bd5390.svg#uikon) format("svg");
  font-weight: normal;
  font-style: normal;
}
[class^="uikon"],
[class*="uikon"] {
  /* use !important to prevent issues with browser extensions that change fonts */
  font-family: 'uikon' !important;
  speak: none;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  /* Enable Ligatures ================ */
  letter-spacing: 0;
  -webkit-font-feature-settings: "liga";
  -ms-font-feature-settings: "liga" 1;
  font-feature-settings: "liga";
  -webkit-font-variant-ligatures: discretionary-ligatures;
  font-variant-ligatures: discretionary-ligatures;
  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  user-select: none;
}

.uik-App__uikon-dropdown_arrow:before {
  content: "\E922";
}

.uik-App__uikon-arrow_left:before {
  content: "\E920";
}

.uik-App__uikon-arrow_right:before {
  content: "\E921";
}

.uik-App__uikon-plus_rounded:before {
  content: "\E900";
}

.uik-App__uikon-pin_rounded_circle:before {
  content: "\E901";
}

.uik-App__uikon-message_2:before {
  content: "\E902";
}

.uik-App__uikon-calendar_2:before {
  content: "\E903";
}

.uik-App__uikon-building_plan:before {
  content: "\E904";
  color: $textSecondary;
}

.uik-App__uikon-tap_click_force_touch:before {
  content: "\E905";
}

.uik-App__uikon-ruler:before {
  content: "\E906";
}

.uik-App__uikon-video_camera:before {
  content: "\E907";
}

.uik-App__uikon-phone_two:before {
  content: "\E908";
}

.uik-App__uikon-smile:before {
  content: "\E909";
}

.uik-App__uikon-attachment:before {
  content: "\E90A";
}

.uik-App__uikon-picture:before {
  content: "\E90B";
}

.uik-App__uikon-view_simple:before {
  content: "\E90C";
}

.uik-App__uikon-lightbulb:before {
  content: "\E90D";
}

.uik-App__uikon-wallet:before {
  content: "\E90E";
}

.uik-App__uikon-view_grid:before {
  content: "\E90F";
}

.uik-App__uikon-view_list:before {
  content: "\E910";
}

.uik-App__uikon-profile_card:before {
  content: "\E911";
}

.uik-App__uikon-front_store:before {
  content: "\E912";
}

.uik-App__uikon-rocket:before {
  content: "\E913";
}

.uik-App__uikon-buildings:before {
  content: "\E914";
}

.uik-App__uikon-building:before {
  content: "\E915";
}

.uik-App__uikon-shopping_bag:before {
  content: "\E916";
}

.uik-App__uikon-arrow-dropdown:before {
  content: "\E917";
}

.uik-App__uikon-check:before {
  content: "\E918";
}

.uik-App__uikon-more:before {
  content: "\E919";
}

.uik-App__uikon-trending_down:before {
  content: "\E91A";
}

.uik-App__uikon-trending_up:before {
  content: "\E91B";
}

.uik-App__uikon-star:before {
  content: "\E91C";
}

.uik-App__uikon-star-filled:before {
  content: "\E91D";
}

.uik-App__uikon-add:before {
  content: "\E91E";
}

.uik-App__uikon-help:before {
  content: "\E91F";
}

.uik-App__uikon-message:before {
  content: "\E9DF";
}

.uik-App__uikon-send_round:before {
  content: "\E9E8";
}

.uik-App__uikon-inbox_paper_round:before {
  content: "\E9F5";
}

.uik-App__uikon-search_left:before {
  content: "\EA27";
}

.uik-App__uikon-settings:before {
  content: "\EA36";
}

.uik-App__uikon-love:before {
  content: "\EA38";
}

.uik-App__uikon-love-fill:before {
  content: "\EA39";
}

.uik-App__uikon-edit:before {
  content: "\EA3E";
}

.uik-App__uikon-multitasking:before {
  content: "\EA69";
}

.uik-App__uikon-gallery_grid_view:before {
  content: "\EA8C";
}

.uik-App__uikon-home:before {
  content: "\EA9A";
}

.uik-App__uikon-profile_round:before {
  content: "\EACB";
}

.uik-App__uikon-profile_plus_round:before {
  content: "\EADD";
}

.uik-App__uikon-clock:before {
  content: "\EAE6";
}

.uik-App__uikon-container:before {
  content: "\EAE9";
}

.uik-App__uikon-globe_network:before {
  content: "\EAFB";
}

.uik-App__uikon-calendar:before {
  content: "\EB5C";
}

.uik-App__uikon-stats:before {
  content: "\EB61";
}

.uik-App__uikon-money_round:before {
  content: "\EB69";
}

.uik-App__uikon-cloud_up:before {
  content: "\EBE3";
}

.uik-App__uikon-image_picture:before {
  content: "\EC3C";
}

.uik-App__uikon-camera:before {
  content: "\EC47";
}

.uik-App__uikon-desktop:before {
  content: "\EF22";
}

.uik-App__uikon-phone:before {
  content: "\EF28";
}

.uikon--close {
  display: inline-block;
  transform: rotate(45deg);
}

// Only for older versions of UI Kit
.uikon__delete .uikon {
  transform: rotate(45deg);
}
</style>
